{
  "name": "dme-ng",
  "version": "0.63.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "serve:local": "ng serve --configuration=local",
    "serve:custom": "ng serve --configuration=custom",
    "serve:dev": "ng serve --configuration=development --host 0.0.0.0",
    "serve:staging": "ng serve --configuration=staging",
    "serve:prod": "ng serve --configuration=production",
    "build:local": "ng build --configuration=local",
    "build:dev": "ng build --configuration=development",
    "build:care": "ng build --configuration=production",
    "build:staging": "ng build --configuration=staging",
    "build:prod": "ng build --configuration=production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:e2e": "playwright test --project=chromium",
    "test:e2e:ui": "playwright test --ui --project=chromium",
    "test:e2e:headed": "playwright test --headed --project=chromium",
    "test:e2e:debug": "playwright test --debug --project=chromium",
    "format-check": "prettier --check \"src/app/**/*.{json,css,scss,less,md,ts,html}\"",
    "format": "prettier --write \"src/app/**/*.{json,css,scss,less,md,ts,html}\"",
    "prepare": "husky"
  },
  "lint-staged": {
    "src/app/**/*.{json,css,scss,less,md,ts,html}": [
      "prettier --write"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.0",
    "@angular/common": "^17.3.0",
    "@angular/compiler": "^17.3.0",
    "@angular/core": "^17.3.0",
    "@angular/forms": "^17.3.0",
    "@angular/google-maps": "^17.2.0",
    "@angular/platform-browser": "^17.3.0",
    "@angular/platform-browser-dynamic": "^17.3.0",
    "@angular/router": "^17.3.0",
    "@googlemaps/js-api-loader": "^1.16.8",
    "@types/googlemaps": "^3.43.3",
    "date-fns": "^4.1.0",
    "dompurify": "3.4.17",
    "laravel-echo": "^2.1.7",
    "mapbox-gl": "^3.15.0",
    "marked": "^12.0.2",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-markdown": "^17.2.1",
    "primeflex": "^3.3.1",
    "primeicons": "^7.0.0",
    "primeng": "^17.18.13",
    "pusher-js": "^8.4.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.6",
    "@angular/cli": "^17.3.6",
    "@angular/compiler-cli": "^17.3.0",
    "@playwright/test": "^1.59.1",
    "@types/jasmine": "~5.1.0",
    "@types/mapbox-gl": "^3.4.1",
    "@types/marked": "^5.0.2",
    "@types/node": "^25.6.0",
    "husky": "^9.1.7",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^16.1.5",
    "prettier": "^3.4.2",
    "typescript": "~5.4.2"
  }
}
